<template>
    <div v-if="config" class="alert-test-dialog">
        <p>
            Sends one <code>{{ config.code }}</code> alert to Slack right away, as the type is configured, with every
            template variable filled with its own name. It is really sent - also outside production - skipping the
            aggregation window, silences and the enabled flag.
        </p>

        <p class="target" data-test="alert-test-channel">
            Channel: <strong>{{ result?.channel || config.channel || "default" }}</strong>
        </p>

        <LaSlackPreview :blocks="result?.blocks">
            <template #label>What will be sent</template>
        </LaSlackPreview>

        <portal to="modalFooter">
            <LaBaseButton
                data-test="send-test-button"
                :disabled="!result || sending"
                text="Send test alert"
                icon="bell-ring-outline"
                stretch
                @click="send()"
            />
        </portal>
    </div>
</template>

<script>
import LaBaseButton from "@/components/button/BaseButton";
import LaSlackPreview from "@/components/alerts/SlackPreview";
import { computed, ref } from "vue";
import store from "@/store/store";
import { getterTypes as dialogGetterTypes } from "@/store/Dialog/types";
import { actionTypes as alertActionTypes } from "@/store/Alerts/types";

export default {
    name: "LaAlertTestDialog",
    components: {
        LaBaseButton,
        LaSlackPreview,
    },
    setup() {
        const config = computed(() => store.getters[dialogGetterTypes.getDialog].item);
        const result = ref(null);
        const sending = ref(false);

        // Render first, so the admin sees the message and the channel before sending
        if (config.value) {
            store
                .dispatch(alertActionTypes.sendTest, { id: config.value.id, dry_run: true })
                .then((data) => (result.value = data))
                .catch(() => {});
        }

        const send = () => {
            if (sending.value) return;
            sending.value = true;
            store
                .dispatch(alertActionTypes.sendTest, { id: config.value.id, dry_run: false })
                .catch(() => {})
                .finally(() => (sending.value = false));
        };

        return { config, result, sending, send };
    },
};
</script>

<style lang="scss" scoped>
p {
    font-size: 0.9rem;
    margin-bottom: 0.6rem;
}
</style>
